// Settings Redux States
import { SET_SETTING_SUCCESS, SET_SETTING_FAIL } from "./actionTypes";

const INIT_STATE = {
  settings: {},
  error: {
    message: "",
  },
};

const SettingsReducer = (state = INIT_STATE, action) => {
  let newState = state;
  switch (action.type) {
    case SET_SETTING_SUCCESS:
      newState = {
        ...state,
        settings: {
          ...state.settings,
          [action.settingsKey]: action.value,
        },
      };
      break;

    case SET_SETTING_FAIL:
      newState = {
        ...state,
        error: {
          message: action.payload,
        },
      };
      break;

    default:
      break;
  }
  return newState;
};

export default SettingsReducer;
